export const translations = {
  hu: {
    // Navbar
    nav: {
      home: 'Főoldal',
      services: 'Szolgáltatások',
      about: 'Rólunk',
      contact: 'Kapcsolat',
      booking: 'Időpontfoglalás'
    },
    
    // Hero Section
    hero: {
      badge: 'EZERMESTER SZOLGÁLTATÁSOK ORSZÁGOSAN',
      title1: 'Megbízható megoldások',
      title2: 'otthonára',
      description: 'Bútor összeszerelés, villanyszerelés, vízszerelés, felújítás, kertgondozás és IT szolgáltatások — egy helyen, országos kiszállással.',
      bookingBtn: 'Időpontfoglalás',
      phone: '06/70-237-8089'
    },
    
    // Services Section
    services: {
      badge: 'SZOLGÁLTATÁSAINK',
      title: 'Amiben segíteni tudunk',
      subtitle: 'Teljeskörű ezermester és IT szolgáltatások, országos kiszállással.',
      detailsLink: 'Részletek →',
      calloutFee: 'Kiszállási díj:',
      calloutText: 'Országos kiszállás',
      calloutPrice: '20.000 Ft + ÁFA',
      calloutNote: '— az ár tartalmazza a felmérés díját is. Megrendelés esetén levonásra kerül a végárból.',
      
      electrical: {
        title: 'Elektromos szerelések',
        description: 'Professzionális villanyszerelési szolgáltatások otthonok és vállalkozások számára. Tapasztalt szakembereink minden elektromos munkát a legmagasabb biztonsági szabványok szerint végeznek.',
        items: [
          'Lámpák, kapcsolók, konnektorok szerelése',
          'Kábelezés, szakadás vizsgálat',
          'Mindennemű villanyszerelés',
          'Kamerarendszerek telepítése (kül- és beltéri, applikációval)'
        ]
      },
      plumbing: {
        title: 'Vízszerelés, fűtés',
        description: 'Teljes körű vízszerelési és fűtési szolgáltatások. Gyors reakcióidő, megbízható munkavégzés. Sürgősségi szolgáltatás elérhető szivárgások esetén.',
        items: [
          'Radiátorok légtelenítése',
          'Szivárgások megszüntetése',
          'Csapok felszerelése, cseréje',
          'Mosógép és mosogatógép bekötése'
        ]
      },
      kitchen: {
        title: 'Konyha & bútorok',
        description: 'Szakszerű bútorösszeszerelés és konyhatelepítés. IKEA, JYSK és minden más márkájú bútor összeszerelését vállaljuk. Gyors, precíz munkavégzés.',
        items: [
          'Konyhabútorok összeszerelése (IKEA, JYSK, stb)',
          'Konyha bontása, elszállítása',
          'Elektromos sütők bekötése',
          'Szagelszívók telepítése',
          'Irodaszékek összeszerelése'
        ]
      },
      renovation: {
        title: 'Lakásfelújítás',
        description: 'Komplett lakásfelújítási szolgáltatások kulcsrakész kivitelezésben. Részleges vagy teljes felújítás, minőségi anyagokkal, szakszerű munkával.',
        items: [
          'Bontás, glettelés, festés, tapétázás',
          'Elektromos és víz bekötések',
          'Gipszkartonozás, vakolás',
          'Burkolás, parketta, járólap lerakása',
          'Ajtó berakás'
        ]
      },
      gardening: {
        title: 'Kertgondozás',
        description: 'Rendszeres és alkalmi kertgondozási szolgáltatások. Fűnyírás, sövénynyírás, kerti hulladék elszállítás. Gondozott kert egész évben.',
        items: [
          'Fűnyírás, zöld hulladék elszállítása',
          'Bokrok karbantartása, nyírása',
          'Kerítés karbantartása, felújítása'
        ]
      },
      it: {
        title: 'Infotechnika & IT',
        description: 'Professzionális IT támogatás magánszemélyek és kisvállalkozások részére. Számítógép javítás, hálózat kiépítés, távoli support. Gyors reagálás.',
        items: [
          'Számítógép összeszerelés, szerviz',
          'Windows telepítés, vírusirtás',
          'Adatmentés, SSD bővítés',
          'Wi-Fi router telepítés, konfiguráció',
          'Hálózat bekötés, kábelezés'
        ]
      },
      digital: {
        title: 'Digitális & Irodai szolgáltatások',
        description: 'Modern digitális szolgáltatások magánszemélyek és vállalkozások számára. Professzionális dokumentumok, weboldalak, AI megoldások és karrier támogatás.',
        items: [
          'Prezentációkészítés (PowerPoint, HU/EN)',
          'Office oktatás: Excel, Word, PowerPoint (kezdő & középhaladó)',
          'Weboldal tervezés és kivitelezés (konzultációval)',
          'AI tanácsadás: prompt engineering, AI agent készítés',
          'Folyamatmodellezés: üzleti folyamatok strukturálása',
          'Karrier támogatás: önéletrajz, LinkedIn, motivációs levél (HU/EN/DE)'
        ]
      }
    },
    
    // About Section
    about: {
      badge: 'RÓLUNK',
      title: 'Miért válasszon minket?',
      description1: 'A HGDS csapata elkötelezett amellett, hogy ügyfeleink otthonát és irodáját a lehetőséges legjobb állapotban tartsuk. Tapasztalt szakembereink országszerte vállalnak ezermester munkákat, lakásfelújítást és informatikai szolgáltatásokat.',
      description2: 'Célunk, hogy egyetlen telefonhívással minden problémájára megoldást nyújtsunk — legyen szó egy csöpögő csapról, teljes lakásfelújításról vagy a számítógépe javításáról.',
      features: {
        fast: {
          title: 'Gyors kiszállás',
          description: 'Rugalmas időpontok, gyors reagálás — az Ön kényelme az első.'
        },
        reliable: {
          title: 'Megbízható szakemberek',
          description: 'Országos kiszállással'
        },
        quality: {
          title: 'Megbízható minőség',
          description: 'Minden munkát precizen, a legmagasabb szakmai sztenderdek szerint végzünk el.'
        },
        pricing: {
          title: 'Átlátható árazás',
          description: 'Előre rögzített kiszállási díj, meglepetések nélkül — amit megbeszélünk, azt számlázuk.'
        },
        team: {
          title: 'Sokoldalú csapat',
          description: 'Villanyszerelőtől az IT specialistáig — mindent egy kézből, egy telefonszámon.'
        }
      }
    },
    
    // Booking Section
    booking: {
      badge: 'IDŐPONTFOGLALÁS',
      title: 'Kérjen ajánlatot most!',
      subtitle: 'Töltse ki az alábbi űrlapot és hamarosan felvesszük Önnel a kapcsolatot, vagy hívjon minket közvetlenül!',
      form: {
        title: 'Küldjön üzenetet',
        subtitle: 'Hamarosan felvesszük Önnel a kapcsolatot.',
        name: 'Név',
        namePlaceholder: 'Kovács János',
        phone: 'Telefonszám',
        phonePlaceholder: '+36 70 xxx xxxx',
        email: 'Email',
        emailPlaceholder: 'pelda@email.hu',
        service: 'Szolgáltatás',
        servicePlaceholder: 'Válasszon szolgáltatást...',
        message: 'Üzenet',
        messagePlaceholder: 'Írja le röviden, miben segíthetünk...',
        submit: 'Ajánlatkérés küldése',
        required: '*'
      },
      success: {
        title: 'Köszönjük!',
        message: 'Hamarosan felvesszük Önnel a kapcsolatot.'
      },
      contactCards: {
        handyman: 'Ezermester Szolgáltatások',
        it: 'Infotechnika & IT',
        digital: 'Digitális & Irodai szolgáltatások',
        callout: 'Kiszállás',
        nationwide: 'Országosan'
      }
    },
    
    // Contact Section
    contact: {
      badge: 'KAPCSOLAT',
      title: 'Keressen bizalommal!',
      subtitle: 'Hívjon minket bátran, vagy foglaljon időpontot online!',
      handyman: 'Ezermester Szolgáltatások',
      it: 'Infotechnika & IT',
      digital: 'Digitális & Irodai',
      callout: 'Kiszállás',
      nationwide: 'Országosan'
    },
    
    // Footer
    footer: {
      copyright: '© 2026 HGDS. Minden jog fenntartva.'
    },
    
    // Service Modal
    modal: {
      servicesTitle: 'Szolgáltatásaink:',
      pricingTitle: 'Pár példa a szolgáltatásainkból:',
      duration: 'Időtartam:',
      note: 'Megjegyzés:',
      noteText: 'Az árak tájékoztató jellegűek és helyszíntől, munka bonyolultságától függően változhatnak. Pontos árajánlatért kérjük, vegye fel velünk a kapcsolatot!',
      bookingBtn: 'Időpontfoglalás',
      close: 'Bezárás',
      unavailable: 'Ideiglenesen nem elérhető'
    }
  },
  
  en: {
    // Navbar
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      booking: 'Book Appointment'
    },
    
    // Hero Section
    hero: {
      badge: 'HANDYMAN SERVICES NATIONWIDE',
      title1: 'Reliable solutions',
      title2: 'for your home',
      description: 'Furniture assembly, electrical work, plumbing, renovation, gardening and IT services — all in one place, with nationwide coverage.',
      bookingBtn: 'Book Appointment',
      phone: '06/70-237-8089'
    },
    
    // Services Section
    services: {
      badge: 'OUR SERVICES',
      title: 'How we can help',
      subtitle: 'Comprehensive handyman and IT services with nationwide coverage.',
      detailsLink: 'Details →',
      calloutFee: 'Call-out fee:',
      calloutText: 'Nationwide coverage',
      calloutPrice: '20,000 HUF + VAT',
      calloutNote: '— the price includes assessment. Deducted from final price upon order.',
      
      electrical: {
        title: 'Electrical Services',
        description: 'Professional electrical services for homes and businesses. Our experienced technicians perform all electrical work according to the highest safety standards.',
        items: [
          'Lamps, switches, outlets installation',
          'Wiring, fault detection',
          'All types of electrical work',
          'Security camera installation (indoor & outdoor, with app)'
        ]
      },
      plumbing: {
        title: 'Plumbing & Heating',
        description: 'Complete plumbing and heating services. Fast response time, reliable workmanship. Emergency service available for leaks.',
        items: [
          'Radiator bleeding',
          'Leak repair',
          'Faucet installation and replacement',
          'Washing machine and dishwasher connection'
        ]
      },
      kitchen: {
        title: 'Kitchen & Furniture',
        description: 'Professional furniture assembly and kitchen installation. We assemble IKEA, JYSK and all other furniture brands. Fast, precise work.',
        items: [
          'Kitchen furniture assembly (IKEA, JYSK, etc.)',
          'Kitchen demolition and removal',
          'Electric oven installation',
          'Range hood installation',
          'Office chair assembly'
        ]
      },
      renovation: {
        title: 'Home Renovation',
        description: 'Complete home renovation services turnkey. Partial or full renovation with quality materials and professional work.',
        items: [
          'Demolition, plastering, painting, wallpapering',
          'Electrical and plumbing connections',
          'Drywall installation, rendering',
          'Tiling, parquet and tile flooring',
          'Door installation'
        ]
      },
      gardening: {
        title: 'Gardening',
        description: 'Regular and occasional gardening services. Lawn mowing, hedge trimming, garden waste removal. Well-maintained garden all year round.',
        items: [
          'Lawn mowing, green waste removal',
          'Bush maintenance and trimming',
          'Fence maintenance and renovation'
        ]
      },
      it: {
        title: 'IT Services',
        description: 'Professional IT support for individuals and small businesses. Computer repair, network setup, remote support. Fast response.',
        items: [
          'Computer assembly and service',
          'Windows installation, virus removal',
          'Data backup, SSD upgrade',
          'Wi-Fi router installation and configuration',
          'Network connection and cabling'
        ]
      },
      digital: {
        title: 'Digital & Office Services',
        description: 'Modern digital services for individuals and businesses. Professional documents, websites, AI solutions and career support.',
        items: [
          'Presentation creation (PowerPoint, HU/EN)',
          'Office training: Excel, Word, PowerPoint (beginner & intermediate)',
          'Website design and development (with consultation)',
          'AI consulting: prompt engineering, AI agent creation',
          'Process modeling: business process structuring',
          'Career support: CV, LinkedIn, cover letter (HU/EN/DE)'
        ]
      }
    },
    
    // About Section
    about: {
      badge: 'ABOUT US',
      title: 'Why choose us?',
      description1: 'The HGDS team is committed to keeping our clients\' homes and offices in the best possible condition. Our experienced professionals undertake handyman work, home renovation and IT services nationwide.',
      description2: 'Our goal is to provide a solution to all your problems with a single phone call — whether it\'s a dripping tap, a complete home renovation or fixing your computer.',
      features: {
        fast: {
          title: 'Fast Service',
          description: 'Flexible appointments, quick response — your convenience comes first.'
        },
        reliable: {
          title: 'Reliable Professionals',
          description: 'With nationwide coverage'
        },
        quality: {
          title: 'Quality Assured',
          description: 'We perform all work precisely, according to the highest professional standards.'
        },
        pricing: {
          title: 'Transparent Pricing',
          description: 'Fixed call-out fee, no surprises — what we agree on is what we charge.'
        },
        team: {
          title: 'Versatile Team',
          description: 'From electrician to IT specialist — everything from one source, one phone number.'
        }
      }
    },
    
    // Booking Section
    booking: {
      badge: 'BOOKING',
      title: 'Request a quote now!',
      subtitle: 'Fill out the form below and we will contact you soon, or call us directly!',
      form: {
        title: 'Send a message',
        subtitle: 'We will contact you soon.',
        name: 'Name',
        namePlaceholder: 'John Doe',
        phone: 'Phone Number',
        phonePlaceholder: '+36 70 xxx xxxx',
        email: 'Email',
        emailPlaceholder: 'example@email.com',
        service: 'Service',
        servicePlaceholder: 'Select a service...',
        message: 'Message',
        messagePlaceholder: 'Briefly describe how we can help...',
        submit: 'Send Request',
        required: '*'
      },
      success: {
        title: 'Thank you!',
        message: 'We will contact you soon.'
      },
      contactCards: {
        handyman: 'Handyman Services',
        it: 'IT Services',
        digital: 'Digital & Office Services',
        callout: 'Coverage',
        nationwide: 'Nationwide'
      }
    },
    
    // Contact Section
    contact: {
      badge: 'CONTACT',
      title: 'Contact us with confidence!',
      subtitle: 'Call us or book an appointment online!',
      handyman: 'Handyman Services',
      it: 'IT Services',
      digital: 'Digital & Office',
      callout: 'Coverage',
      nationwide: 'Nationwide'
    },
    
    // Footer
    footer: {
      copyright: '© 2026 HGDS. All rights reserved.'
    },
    
    // Service Modal
    modal: {
      servicesTitle: 'Our Services:',
      pricingTitle: 'A few examples from our services:',
      duration: 'Duration:',
      note: 'Note:',
      noteText: 'Prices are indicative and may vary depending on location and complexity of work. Please contact us for an accurate quote!',
      bookingBtn: 'Book Appointment',
      close: 'Close',
      unavailable: 'Temporarily unavailable'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
